import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  NgZone,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { AuthUser } from 'src/app//shared/models/auth/AuthUser';
import { Notification } from 'src/app//shared/models/notification/Notification';
import { NotificationsSearchModel } from 'src/app//shared/models/notification/NotificationsSearchModel';
import { SignalEventType } from 'src/app//shared/models/SignalModel';
import { EntityEnumSLA } from 'src/app//shared/models/sla/enums/EntityEnumSLA';
import { RolesEnum } from 'src/app//shared/models/users/roles/enums/roles';
import { NotificationType } from 'src/app/shared/models/notification/NotificationType';
import { AuthenticationService } from 'src/app/shared/services/authentication.service';
import { NavigationService } from 'src/app/shared/services/navigation.service';
import { NotificationsService } from 'src/app/shared/services/notifications.service';
import { SignalRService } from 'src/app/shared/services/signal-rservice.service';
import { TranslationService } from 'src/app/shared/services/translation.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit, OnDestroy {
  @Input() forExtract = true;
  @Input() customClass = '';
  @Input() showMenu = false;
  isArabic = false;
  @Output() sidebarTrigger = new EventEmitter();
  notificationNumber!: number;
  currentUser = new AuthUser();
  notifLoading = false;
  messagesLoading = false;
  pageNumber = 1;
  pageSize = 10;
  pageCount!: number;
  notificationsList: Array<Notification> = [];
  nmessagesList: [] = [];
  notificationType = NotificationType;
  NotificationsObject: NotificationsSearchModel =
    new NotificationsSearchModel();
  activeAlerts = {};
  notificationsResult: any = {
    unSeenNotificationsCount: 0,
    totalCount: 0,
  };
  selectedText = '';
  @ViewChild('selectedTextInput') selectedTextInput!: ElementRef;
  @Input() logo = '';


  models = [
    { name: 'Hospital', value: 'hospital', key: EntityEnumSLA.hospital },
    { name: 'Clinic', value: 'clinic', key: EntityEnumSLA.clinic },
    { name: 'Lab', value: 'lab', key: EntityEnumSLA.lab },
    {
      name: 'Scanning Center',
      value: 'scanningCenter',
      key: EntityEnumSLA.scanningCenter,
    },
  ];

  openSideNav!: boolean;
  showSearch = false;

  subscriptions: Subscription[] = [];

  constructor(
    public zone: NgZone,
    private router: Router,
    private route: ActivatedRoute,
    public translate: TranslateService,
    private signalRService: SignalRService,
    private snackBar: MatSnackBar,
    private notificationsService: NotificationsService,
    public dialogRef: MatDialog,
    public navService: NavigationService,
    private translationService: TranslationService,
    private authenticationService: AuthenticationService
  ) {
    // this.currentUser = this.authenticationService.currentUserValue;
    this.getNotifications(false);
    // this.getMessages();
    // this.signalRService.startConnection();
    // this.signalRService.changeNotificationCount(this, this.updateNotification);
    // this.signalRService.handleNewChatMessageEvent(this, this.updateMessages);
    // this.signalRService.handleSignOutEvent(this, this.autoLogout);
    this.subscriptions.push(
      this.signalRService.getDataStream<string>(SignalEventType.changeNotificationCount)
        .subscribe(message => {
          this.changeNotificationCount(message.data);
        })
    );
  }

  autoLogout(context: any, userId: any) {
    context.zone.run(() => {
      context.authenticationService.logout();
    });
  }

  ngOnInit() {
    this.authenticationService.currentUserSubject.subscribe((user: any) => {
      this.currentUser = user;
    });


    // this.router.events
    //   .pipe(filter((event) => event instanceof NavigationEnd)) // Filter only for navigation events
    //   .subscribe((event: NavigationEnd) => {
    //     // this.currentRoute = event.urlAfterRedirects; // Set the current route
    //     // console.log(this.currentRoute); // Check the current route in console
    //     this.checkIfSearch();
    //   });

  }
  // SignalR
  changeNotificationCount(data: any) {
    this.getNotifications(true);
  }

  updateMessages(context: any) {
    context.zone.run(() => {
      context.getMessages();
      context.openSnackBar('You have a new message');
    });
  }

  get checkIfSearch() {
    const currentUrl = this.router.url;
    const match = currentUrl.match(/\/admin\/courses\/(\d+)/);
    return match;
  }

  openSnackBar(msg: any) {
    this.snackBar.open(msg, '✖', {
      duration: 10000,
      horizontalPosition: 'end',
      verticalPosition: 'bottom',
    });
  }

  // Notifications
  openNotificationPanel() {
    // this.notificationsResult.unSeenNotificationsCount = 0;
    // this.getUnSeeNotifications();
  }

  getUnSeeNotifications(notification: any, url: any, params: any = null): any {
    if (!notification.isSeen) {
      const param = { NotificationID: notification.notificationId };
      this.notificationsService.SeeNotifications(param).subscribe(
        (result: any) => {
          // this.notificationsResult.unSeenNotificationsCount = result;
          this.getNotifications(true);
          return this.router.navigate(url, { queryParams: params });
        },
        (err: any) => {
          console.error(err);
        }
      );

    } else {
      return this.router.navigate(url, { queryParams: params });
    }
  }
  getNextPage() {
    if (this.pageNumber < this.pageCount - 1) {
      this.pageNumber += 1;
      this.getNotifications(false);
    }
  }
  getNotifications(update: any) {
    if (update) {
      this.pageNumber = 1;
      this.notificationsList = [];
    }
    this.notifLoading = true;
    this.NotificationsObject.pageSize = this.pageSize;
    this.NotificationsObject.pageNumber = this.pageNumber;

    this.notificationsService
      .GetNotifications(this.NotificationsObject)
      .subscribe(
        (result: any) => {
          this.notificationsResult = result as any;
          this.pageCount = Math.ceil(
            this.notificationsResult.totalCount / this.pageSize
          );
          if (
            this.notificationsResult.pageData &&
            this.notificationsResult.pageData.length
          ) {
            this.notificationsList = this.notificationsList.concat(
              this.notificationsResult.pageData
            );
          }
          this.notifLoading = false;
        },
        (err: any) => {
          this.notifLoading = false;
          console.error(err);
        }
      );
  }

  // Messages
  // getMessages() {
  //   this.chatService.GetMissedConversations().subscribe(
  //     (result: any) => {
  //       this.messagesLoading = false;
  //       this.nmessagesList = result as any;
  //     },
  //     (err: any) => {
  //       this.messagesLoading = false;
  //     }
  //   );
  // }

  // Actions


  logout() {
    this.authenticationService.logout();
    this.router.navigate(['/login']);
  }

  toggelSidebar() {
    const state = this.navService.sidebarState;
    state.sidenavOpen = !state.sidenavOpen;
  }

  hasPermission(permission: string) {
    return this.authenticationService.hasPermission(permission);
  }

  getEntity(key: any) {
    return this.models.find((item) => item.key === key);
  }

  navigateToSearchReasult() {
    if (this.selectedText) {
      this.selectedTextInput.nativeElement.blur();
      // this.coursesService.openSearchSideNav.next({ selectedText: this.selectedText })
    }
  }

  // Actions
  changeLanguage() {
    if (localStorage.getItem('language') === 'ar') {
      this.translationService.setLanguage('en');
    } else {
      this.translationService.setLanguage('ar');
    }
    window.location.reload();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

}
